import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {WizardCustomerDataComponent} from './components/wizard-customer-data/wizard-customer-data.component';
import {PageComponent, PageSize} from '../../../shared/components/page/page.component';
import {VehicleBrand} from '../../../domain/core/vehicle-brand.model';
import {LegalEntity} from '../../../domain/core/legal-entity.model';
import {WizardCommunicationComponent} from './components/wizard-communication/wizard-communication.component';
import {WizardProfilingComponent} from './components/wizard-profiling/wizard-profiling.component';
import {WizardDataSharingComponent} from './components/wizard-data-sharing/wizard-data-sharing.component';
import {WizardMailSummaryComponent} from './components/wizard-mail-summary/wizard-mail-summary.component';
import {WizardType} from './wizard-type.enum';
import {WizardActionButtonsComponent} from './components/wizard-action-buttons/wizard-action-buttons.component';
import {CustomerWizardResponse} from '../../../domain/data/customer-wizard-response.data';
import {WizardStartPageComponent} from './components/wizard-start-page/wizard-start-page.component';
import {WizardService} from '../../../shared/services/wizard.service';
import * as pdfjsLib from 'pdfjs-dist';
import {WizardEndPageComponent} from './components/wizard-end-page/wizard-end-page.component';
import {WizardDigSigCommunicationComponent} from './components/wizard-communication/wizard-dig-sig-communication/wizard-dig-sig-communication.component';
import {WizardDigSigCustomerDataComponent} from './components/wizard-customer-data/wizard-dig-sig-customer-data/wizard-dig-sig-customer-data.component';
import {NgClass} from '@angular/common';

@Component({
  selector: 'app-wizard',
  imports: [
    WizardCustomerDataComponent,
    PageComponent,
    WizardCommunicationComponent,
    WizardProfilingComponent,
    WizardDataSharingComponent,
    WizardMailSummaryComponent,
    WizardActionButtonsComponent,
    WizardStartPageComponent,
    WizardEndPageComponent,
    WizardDigSigCommunicationComponent,
    WizardDigSigCustomerDataComponent,
    NgClass
  ],
  templateUrl: './wizard.component.html',
  standalone: true,
})
export class WizardComponent implements OnInit {
  @Input() wizardType!: WizardType;
  @Input() customerWizardResponse: CustomerWizardResponse;
  @Input() brand: VehicleBrand;
  @Input() legalEntity: LegalEntity;
  @Input() signatures?: { [step: number]: string };

  @Output() stepAccepted = new EventEmitter<{ step: number, signature: string }>();
  @Output() stepSkipped = new EventEmitter<{ step: number }>();

  currentStep = 0;
  skipAllInProgress = false;
  confirmWithMailInProgress = false;
  confirmWithoutMailInProgress = false;
  noDigitalSignatures = false;
  noConfirmations = false;
  dshImg = '';

  protected readonly PageSize = PageSize;
  protected readonly WizardType = WizardType;

  constructor(
    private wizardService: WizardService
  ) {
    pdfjsLib.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjsLib.version}/build/pdf.worker.min.mjs`;
  }

  ngOnInit(): void {
    this.loadDsh();
    console.log(this.legalEntity);
  }

  nextStep() {
    this.currentStep++;
  }

  previousStep() {
    if (this.currentStep > 0) {
      this.currentStep--;
    }
  }

  goToTheLastStep() {
    if (this.wizardType === WizardType.EWE_BY_EMAIL) {
      this.currentStep = 6;
    } else if (this.wizardType === WizardType.DIGITAL_SIGNATURE)
      this.currentStep = 5;
  }

  showActionButtons() {
    if (this.wizardType === WizardType.EWE_BY_EMAIL) {
      return this.currentStep > 1 && this.currentStep < 5;
    } else if (this.wizardType === WizardType.DIGITAL_SIGNATURE) {
      return this.currentStep > 0 && this.currentStep < 4;
    } else {
      return false;
    }
  }

  onAccept(signature: string) {
    this.stepAccepted.emit({ step: this.currentStep, signature });
  }

  onSkip() {
    this.stepSkipped.emit({ step: this.currentStep });
  }

  getContactEvent(key: string) {
    if (!this.customerWizardResponse?.contactEventList) {
      return null;
    }

    for (const e of this.customerWizardResponse.contactEventList) {
      if (e.eventName === key) {
        return e;
      }
    }
    return null;
  }

  loadDsh() {
    this.wizardService.getDshDocumentPdf(this.brand).subscribe(async buffer => {
      const pdf = await pdfjsLib.getDocument({ data: buffer }).promise;

      const page = await pdf.getPage(1);
      const viewport = page.getViewport({ scale: 2 });

      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d')!;

      canvas.width = viewport.width;
      canvas.height = viewport.height;

      await page.render({
        canvasContext: context,
        viewport,
        canvas
      }).promise;

      this.dshImg = canvas.toDataURL('image/png');
    });
  }
}
